module.exports = __webpack_public_path__ + "img/sv14.92d6f116.svg";